<script lang="tsx">
import { computed, defineComponent, type PropType } from 'vue'
import { createNamespace } from '@bd/vue3-utils'
import { type TableColumnType } from 'ant-design-vue'
import { PopoverTable } from '-/Common/PopoverTable'
import { Tag } from '-/Common/Tag'
import { JtZchSocialSecurityStatus } from '-/Business/Status'

const [name] = createNamespace('SocialSecurityCol')

export default defineComponent({
  name,
  props: {
    data: {
      type: Array as PropType<any[]>,
      default: () => []
    }
  },
  setup(props) {
    const totalCount = computed(() => props.data.length)
    const buyCount = computed(() => props.data.filter(item => item.isBuying).length)
    const unBuyCount = computed(() => totalCount.value - buyCount.value)

    const columns: TableColumnType[] = [
      {
        title: '姓名',
        dataIndex: 'userName',
        width: 120
      },
      {
        title: '状态',
        dataIndex: 'isBuying',
        width: 120,
        customRender({ text }) {
          return <JtZchSocialSecurityStatus value={text} />
        }
      }
    ]
    return () => (
      <PopoverTable width='280px' dataSource={props.data} columns={columns} pagination={false} size='middle'>
        <div>
          <Tag color='success'>已购买：{buyCount.value} 人</Tag>
          <br />
          <Tag color='error' class='mt-8'>
            未购买：{unBuyCount.value} 人
          </Tag>
        </div>
      </PopoverTable>
    )
  }
})
</script>
